import { render, staticRenderFns } from "./best-sellers.vue?vue&type=template&id=73addcf7&"
import script from "./best-sellers.vue?vue&type=script&lang=js&"
export * from "./best-sellers.vue?vue&type=script&lang=js&"
import style0 from "./best-sellers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports